'use client';

import { Controller, useFormContext } from 'react-hook-form';

import { Switch  } from '@packages/web-design-systems';
import type { SwitchProps } from '@packages/web-design-systems';

import type { FormBaseInputProps } from '../../../types';
import { FormField } from '../../wrapper';

export type SwitchInputProps<T> = FormBaseInputProps<T> & Omit<SwitchProps, 'name'>;

export const SwitchInput = <T extends Record<string, unknown>>({
	helperText,
	label,
	name,
	optionalText,
	required,
	...switchInputProps
}: SwitchInputProps<T>) => {
	const { control } = useFormContext<T>();

	return (
		<FormField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={required}
		>
			<Controller
				control={control}
				name={name}
				render={({ field }) => (
					<Switch
						checked={field.value as boolean | undefined}
						inputProps={{ onBlur: field.onBlur }}
						name={name}
						onCheckedChange={({ checked }) => field.onChange(checked)}
						{...switchInputProps}
					/>
				)}
			/>
		</FormField>
	);
};
